export default __webpack_public_path__ + "./img/logoutIcon.d4cedeb5d5ed7e0ba713b64d16181b4a.png";